export default "__VITE_ASSET__BxgjbPIH__"